// 此文件由webpack插件自动生成，请勿手动修改
// 生成时间: 2026/1/26 上午10:33:42

/**
 * 语言包支持映射表
 * key: 版本文件夹名称
 * value: 该版本支持的语言代码数组
 */
export const LANG_SUPPORT_MAP = {
    "20200000": [
        "da",
        "de",
        "en",
        "es",
        "fi",
        "fr",
        "it",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "tr",
        "ua"
    ],
    "20201220": [
        "ch",
        "cs",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fi",
        "fr",
        "hk",
        "hu",
        "id",
        "it",
        "jp",
        "kr",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "sa",
        "se",
        "th",
        "tr",
        "tw",
        "ua",
        "vn"
    ],
    "20210430": [
        "ch",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fr",
        "hu",
        "it",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "tr",
        "ua"
    ],
    "20220928": [
        "da",
        "de",
        "el",
        "en",
        "es",
        "fr",
        "hu",
        "it",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "tr",
        "ua"
    ],
    "20230320": [
        "en"
    ],
    "20230926": [
        "ch",
        "cz",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fi",
        "fr",
        "he",
        "hr",
        "hu",
        "it",
        "ka",
        "kr",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "sa",
        "se",
        "si",
        "sk",
        "th",
        "tr",
        "tw",
        "ua",
        "vn"
    ],
    "20240104": [
        "ch",
        "cz",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fi",
        "fr",
        "he",
        "hr",
        "hu",
        "it",
        "ka",
        "kr",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "sa",
        "se",
        "si",
        "sk",
        "th",
        "tr",
        "tw",
        "ua",
        "vn"
    ],
    "20240119": [
        "ch",
        "cz",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fi",
        "fr",
        "he",
        "hr",
        "hu",
        "it",
        "ka",
        "kr",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "sa",
        "se",
        "si",
        "sk",
        "th",
        "tr",
        "tw",
        "ua",
        "vn"
    ],
    "20241122": [
        "ch",
        "de",
        "el",
        "en",
        "es",
        "fr",
        "hu",
        "it",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "tr",
        "ua"
    ],
    "20241126": [
        "ch",
        "cz",
        "de",
        "ee",
        "el",
        "en",
        "es",
        "fr",
        "he",
        "hr",
        "hu",
        "it",
        "ka",
        "kr",
        "lt",
        "nl",
        "pl",
        "pt",
        "ro",
        "ru",
        "sa",
        "se",
        "th",
        "tr",
        "tw",
        "ua",
        "vn"
    ]
};

/**
 * 获取指定版本支持的语言列表
 * @param {string} version - 版本文件夹名称
 * @returns {string[]} 支持的语言代码数组
 */
export function getSupportedLangs(version) {
    return LANG_SUPPORT_MAP[version] || [];
}

/**
 * 检查指定版本是否支持某种语言
 * @param {string} version - 版本文件夹名称
 * @param {string} lang - 语言代码
 * @returns {boolean} 是否支持
 */
export function isLangSupported(version, lang) {
    const supportedLangs = getSupportedLangs(version);
    return supportedLangs.includes(lang);
}

/**
 * 获取回退语言
 * 优先使用英文，如果不支持英文则使用第一个支持的语言
 * @param {string} version - 版本文件夹名称
 * @param {string} requestedLang - 请求的语言代码
 * @returns {string|null} 回退语言代码，如果没有可用语言则返回null
 */
export function getFallbackLang(version, requestedLang) {
    const supportedLangs = getSupportedLangs(version);
    
    if (supportedLangs.length === 0) {
        return null;
    }
    
    // 如果请求的语言被支持，直接返回
    if (supportedLangs.includes(requestedLang)) {
        return requestedLang;
    }
    
    // 优先使用英文
    if (supportedLangs.includes('en')) {
        return 'en';
    }
    
    // 否则使用第一个支持的语言
    return supportedLangs[0];
}



// WEBPACK FOOTER //
// ./src/utils/const/lang-support-map.js